import type { ReplacementOrderErrorCode } from "@/services/replacement-order/replacement-order.constants";

const REVIEW_STRINGS = "replacement.review";

export const REVIEW_STRING_KEYS = {
  deviceHeading: `${REVIEW_STRINGS}.deviceHeading`,
  keyboardLayoutLabel: `${REVIEW_STRINGS}.keyboardLayoutLabel`,
  deliveryHeading: `${REVIEW_STRINGS}.deliveryHeading`,
  edit: `${REVIEW_STRINGS}.edit`,
  editDevice: `${REVIEW_STRINGS}.editDevice`,
  editDelivery: `${REVIEW_STRINGS}.editDelivery`,
  submitError: `${REVIEW_STRINGS}.submitError`,
  viewExistingOrder: `${REVIEW_STRINGS}.viewExistingOrder`,
} as const;

export const submitErrorKey = (code: ReplacementOrderErrorCode): string =>
  `${REVIEW_STRINGS}.submitErrors.${code}`;
